import { createFileRoute } from '@tanstack/react-router'

import { AchReturnsScreen } from './-components/ach-returns-screen.tsx'

export const Route = createFileRoute('/payments/ach-returns')({
  component: AchReturnsScreen
})
